module.exports = __webpack_public_path__ + "img/icon32.96e14986.png";